import React, { useState } from 'react';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import ScrollingGallery from './ScrollingGallery';
import ContactForm from './ContactForm';

const Home = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-icon">
              <img 
                src="https://customer-assets.emergentagent.com/job_sleek-landing-94/artifacts/gu1ozbg3_Code%20Composite%20Final%20Logo-02.jpg" 
                alt="Code Composite" 
                className="logo"
              />
            </div>
            <nav className="nav-links">
              <a href="#about" className="nav-link">About</a>
              <a href="#contact" className="nav-link">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section" id="about">
        <div className="container hero-content">
          <div className="hero-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_sleek-landing-94/artifacts/9w2g27nu_Code%20Composite%20Final.png" 
              alt="Code Composite" 
              className="brand-logo-full"
            />
          </div>
          <div className="hero-description">
            <h2 className="section-heading">Design &amp; Engineering Support for USA Manufacturing Leader</h2>
            <p className="description-text">
              Specializing in award-winning sustainable architectural metal products for interior and exterior applications:
            </p>
            <ul className="product-list">
              <li>Metal Ceilings</li>
              <li>Metal Walls</li>
              <li>Acoustical Ceilings</li>
              <li>Acoustical Wall Panels</li>
              <li>Column Covers</li>
              <li>Data Center Ceilings</li>
              <li>Chase Walls</li>
              <li>Partition Closures</li>
              <li>Perforated Panels</li>
              <li>Corrugated Panels</li>
              <li>Corner Guards</li>
              <li>Soffit Systems</li>
              <li>Cladding Systems</li>
              <li>Torsion Spring Ceilings</li>
              <li>Security Ceilings</li>
              <li>Security Walls</li>
              <li>Cleanroom Ceilings</li>
            </ul>
            <p className="description-text">
              Serving commercial, healthcare, educational, institutional, and industrial environments as an industry leader in custom architectural specialties.
            </p>
          </div>
        </div>
      </section>

      {/* Projects Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="gallery-title">Our Projects</h2>
        </div>
        <ScrollingGallery />
      </section>

      {/* Coming Soon Section */}
      <section className="coming-soon-section">
        <div className="container">
          <div className="coming-soon-content">
            <h2 className="team-intro">We are Team CoCo !</h2>
            <h2 className="coming-soon-title">More details assembling soon</h2>
            <div className="coming-soon-animation">
              <div className="assembly-dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact">
        <div className="container">
          <h2 className="section-title">Get In Touch</h2>
          
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info">
              <div className="info-card">
                <div className="info-icon">
                  <MapPin size={24} />
                </div>
                <div className="info-content">
                  <h3 className="info-title">Visit Us</h3>
                  <p className="info-text">
                    #783, Ground Floor<br />
                    C/O Beginest Co-Work<br />
                    1st Cross, 12th Main,<br />
                    HAL 2nd Stage, Indiranagar,<br />
                    Bengaluru, Karnataka<br />
                    Pin: 560008
                  </p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">
                  <Phone size={24} />
                </div>
                <div className="info-content">
                  <h3 className="info-title">Call Us</h3>
                  <p className="info-text">
                    <strong>Landline:</strong> <a href="tel:+918041614620">+91 80 41614620</a><br />
                    <strong>Mobile:</strong> <a href="tel:+918217763229">+91 8217763229</a><br />
                    <a href="tel:+917406079166">+91 7406079166</a><br />
                    <a href="tel:+917406071166">+91 7406071166</a>
                  </p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">
                  <Mail size={24} />
                </div>
                <div className="info-content">
                  <h3 className="info-title">Email Us</h3>
                  <p className="info-text">
                    <a href="mailto:admin@codecomposite.com">admin@codecomposite.com</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <ContactForm />
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <h3 className="map-title">Find Us on the Map</h3>
            <div className="map-container">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4055.1037326469072!2d77.63822977520739!3d12.969322114927994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15207f9fb8bb%3A0x7d4348376e22a868!2sCode%20Composite!5e1!3m2!1sen!2sin!4v1771568800476!5m2!1sen!2sin" 
                width="100%" 
                height="450" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Code Composite Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-left">
              <p className="footer-text">© 2024 Code Composite. All rights reserved.</p>
            </div>
            <div className="footer-right">
              <a 
                href="https://in.linkedin.com/company/code-composite" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="LinkedIn"
              >
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
